/** Support contact used when `VITE_SUPPORT_URL` is not set (same finance desk as the sibling arbitrage site). */
export const DEFAULT_SUPPORT_URL = "https://t.me/HelpManagerX";

function httpsUrl(value: unknown) {
  if (typeof value !== "string" || !value) return null;
  try {
    const url = new URL(value);
    return url.protocol === "https:" ? url.toString() : null;
  } catch {
    return null;
  }
}

export function getSupportUrl(): string {
  return httpsUrl(import.meta.env["VITE_SUPPORT_URL"]) ?? DEFAULT_SUPPORT_URL;
}
